<template>
  <section class="f-2" v-show="isShow">
    <div
      ref="content"
      class="f-sidebar-content"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <div
        class="sidebar_container"
        v-for="(side, index) in sideList"
        :key="side.id"
      >
        <div
          class="sidebar_item"
          :class="{ 'f-sidebar-active': isActive(side.id) }"
          @click="scrollToSection(side)"
        >
          <div class="f-sidebar"></div>
          <div class="sidebar_text" v-show="showText">
            {{ side.text }}
          </div>
        </div>
        <div class="f-divide" v-if="index < sideList.length - 1"></div>
      </div>
    </div>
  </section>
</template>
<script>
import { beautyScroll, scrollHandle } from '@/v2/auto/bus_key'

export default {
  data() {
    return {
      preload_: true,
      lastScrollTop: 0, // 记录上一次滚动位置
      isShow: true,
      activeId: 'home',
      clickScroll: false,
      showText: false,
      sideList: [
        { id: 'home', text: '首页' },
        { id: 'beauty', text: '美' },
        { id: 'wisdom', text: '智' },
        { id: 'newborn', text: '新生' },
      ],
    }
  },
  mounted() {
    this.calculateBackground()
    this.$event.on(scrollHandle, this.handleScroll)
  },
  methods: {
    calculateBackground() {
      if (!this.$refs.content) return
      const { left, top } = this.$refs.content.getBoundingClientRect()
      const bgElements = document
        .elementsFromPoint(left + 15, top + 88)
        .filter((el) => !this.$refs.content.contains(el))
      const bgElement = bgElements.find((el) => {
        const bgColor = getComputedStyle(el).backgroundColor
        return bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent'
      })
      if (bgElement) {
        const opacity = getComputedStyle(bgElement).opacity || 1
        const bgColor = getComputedStyle(bgElement).backgroundColor
        const rgbValues = bgColor.match(/\d+/g).map(Number)
        const brightness =
          (0.299 * rgbValues[0] + 0.587 * rgbValues[1] + 0.114 * rgbValues[2]) /
          255
        const isDark = brightness < 0.5 && opacity > 0.5
        this.$el.style.setProperty(
          '--dynamic-box-color',
          isDark ? '#FFFFFF33' : '#00000026',
        )
        this.$el.style.setProperty(
          '--dynamic-bg-rgb',
          isDark ? '#2F2F2F' : '#FFFFFF88',
        )
        this.$el.style.setProperty(
          '--dynamic-item-color',
          isDark ? '#FFFFFF26' : '#DADADA',
        )
        this.$el.style.setProperty(
          '--dynamic-text-color',
          isDark ? '#FFFFFF99' : '#00000099', // Increased opacity for better contrast
        )
        this.$el.style.setProperty(
          '--dynamic-item-hover-color',
          isDark ? '#FFFFFFCC' : '#00000080', // Kept original as per analysis, problem was text color
        )
        this.$el.style.setProperty(
          '--dynamic-text-hover-color',
          isDark ? '#FFFFFFCC' : '#000000CC', // Increased opacity for better contrast
        )
      }
    },
    handleScroll() {
      this.calculateBackground()
      if (!this.clickScroll) {
        const currentScrollTop = window.scrollY // 当前滚动位置

        // 判断是否往下滚动
        if (currentScrollTop > this.lastScrollTop) {
          this.isShow = false
        } else {
          this.isShow = true
        }

        // 更新上一次滚动位置
        this.lastScrollTop = currentScrollTop
        this.sideList.forEach((side) => {
          const target = document.getElementById(side.id)
          if (target) {
            const rect = target.getBoundingClientRect()
            const offset = side.offset || 0 // 使用 side.offset，如果没有定义则默认为 0
            if (
              offset - rect.top >= 0 &&
              rect.top - offset < window.innerHeight
            ) {
              this.activeId = side.id // 更新当前激活的区域
            }
          }
        })
      }
    },
    scrollToSection(side) {
      const id = side.id
      this.activeId = id // 更新当前激活的区域
      const offset = side.offset || 0
      const target = document.getElementById(id)
      if (target) {
        const rect = target.getBoundingClientRect()
        const targetPosition = rect.top + window.scrollY - offset // 计算目标位置
        window.scrollTo({
          top: targetPosition,
          behavior: 'instant',
        })
        // 检测滚动是否完成
        const checkIfScrollFinished = () => {
          const currentScroll = window.scrollY
          if (Math.abs(currentScroll - targetPosition) < 1) {
            this.clickScroll = false // 滚动完成后更新状态
          } else {
            setTimeout(checkIfScrollFinished, 50) // 继续检测
          }
        }

        this.clickScroll = true // 标记正在滚动
        setTimeout(checkIfScrollFinished, 50) // 开始检测
      }
    },
    isActive(id) {
      return this.activeId === id
    },
    handleMouseEnter() {
      this.showText = true
    },
    handleMouseLeave() {
      this.showText = false
    },
  },
}
</script>
<style lang="less" scoped>
.f-2 {
  position: fixed;
  height: 100vh;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  display: flex;

  .f-sidebar-content {
    position: relative;
    padding: 8px 0;
    margin: auto 20px;
    background-color: var(--dynamic-bg-rgb);
    backdrop-filter: blur(10px);
    mix-blend-mode: luminosity;
    box-shadow: 0px 0px 20px 0 var(--dynamic-box-color);
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    .sidebar_container {
      width: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .sidebar_item {
      position: relative;
      background: var(--dynamic-item-color);
      color: var(--dynamic-text-color);
      cursor: pointer;
      border-radius: 10px;
      &:hover {
        background: var(--dynamic-item-hover-color);
        color: var(--dynamic-text-hover-color);
      }
      &:active {
        background-color: #1368fb;
        color: #1368fb;
      }
      .f-sidebar {
        width: 8px;
        height: 8px;
      }

      .sidebar_text {
        font-size: 14px;
        position: absolute;
        top: -3px;
        width: 30px;
        height: 40px;
        padding-right: 15px;
        text-align: right;
        left: -45px;
      }
    }
    .f-sidebar-active {
      background-color: #1368fb;
      color: #1368fb;
      &:hover {
        background-color: #1368fb;
        color: #1368fb;
      }
    }
    .f-divide {
      width: 1px;
      background-color: var(--dynamic-item-color);
      height: 16px;
      margin-top: 8px;
    }
  }
}
</style>
